import defaultParticipanteFoto from '@/assets/images/default-gladiador.png';
import { resolveMediaUrl } from '@/helpers/mediaUrl';

export const DEFAULT_PARTICIPANTE_FOTO = defaultParticipanteFoto;

export function participanteFotoSrc(url) {
  if (!url || typeof url !== 'string' || !url.trim()) {
    return DEFAULT_PARTICIPANTE_FOTO;
  }
  return resolveMediaUrl(url);
}
